export default __webpack_public_path__ + "static/media/Location_Rheinland-Pfalz.4b5ed467.svg";